"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentByMe = void 0;
function sentByMe(message, me) {
    if ("sender" in message) {
        return message.sender === me;
    }
    return true;
}
exports.sentByMe = sentByMe;
